import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../hooks'
import { FormFieldSelectNG } from '../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../Formik'
import { EmailFormContext } from '../../EmailForm.context'
import { EmailTemplateSelect } from '../../EmailTemplateSelect'
import {
  EMAIL_CREATION_FORM_FIELD_NAME_TEMPLATE,
  EMAIL_CREATION_FORM_TEMPLATE_API_PARAMS,
  EMAIL_CREATION_FORM_TEMPLATE_MASS_API_PARAMS,
} from '../EmailCreationForm.constants'

import * as styles from '../EmailCreationForm.module.css'

function TemplateField({ apiParams, mass }) {
  const { t } = useTranslation()

  const { blocked } = useContext(EmailFormContext)

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  const baseApiParams = apiParams ?? EMAIL_CREATION_FORM_TEMPLATE_API_PARAMS

  const templateApiParams = mass
    ? { ...baseApiParams, ...EMAIL_CREATION_FORM_TEMPLATE_MASS_API_PARAMS }
    : baseApiParams

  return (
    <FormikField
      Component={FormFieldSelectNG}
      Select={EmailTemplateSelect}
      apiParams={templateApiParams}
      blocked={blocked}
      controlProps={{
        blocked,
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: { placeholder: t('Email.TemplatePlaceholderKey') },
        },
      }}
      fieldComponentProps={{
        label: `${t('Email.TemplateLabelKey')}:`,
        labelClassName: styles.fieldLabel,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      name={EMAIL_CREATION_FORM_FIELD_NAME_TEMPLATE}
    />
  )
}

export default TemplateField
